const StarRating: React.FC<{ rating: number }> = ({ rating }) => {
  if (rating < 0 || rating > 5) {
    console.error('Rating must be between 0 and 5');
    return null;
  }

  return (
    <div className="flex gap-[0.125rem]">
      {[...Array(5)].map((_, index) => (
        <div
          key={index}
          className={
            index < rating ? 'text-tertiary-main' : 'text-tertiary-lighter/50'
          }
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 21 21"
            fill="currentColor"
          >
            <path
              d="M20.9702 8.25086C20.9702 7.93995 20.7351 7.74675 20.2642 7.67111L13.9381 6.75121L11.1027 1.01713C10.9432 0.67265 10.7371 0.500488 10.4852 0.500488C10.2332 0.500488 10.0273 0.67265 9.86767 1.01713L7.03203 6.75121L0.705662 7.67111C0.235272 7.74675 0 7.93995 0 8.25086C0 8.42735 0.105029 8.62906 0.315088 8.85583L4.90236 13.317L3.81865 19.6182C3.80179 19.7359 3.79344 19.82 3.79344 19.8703C3.79344 20.0468 3.83752 20.1958 3.92569 20.3178C4.01386 20.4397 4.14611 20.5005 4.32261 20.5005C4.47389 20.5005 4.64187 20.4504 4.82672 20.3494L10.485 17.375L16.1438 20.3494C16.3204 20.4502 16.4884 20.5005 16.6477 20.5005C16.8162 20.5005 16.9441 20.4399 17.0323 20.3178C17.1203 20.1959 17.1644 20.0468 17.1644 19.8703C17.1644 19.7611 17.1602 19.6771 17.1517 19.6182L16.0678 13.317L20.6424 8.85583C20.8611 8.63741 20.9702 8.43571 20.9702 8.25086Z"
              fill="currentColor"
            />
          </svg>
        </div>
      ))}
    </div>
  );
};

export default StarRating;
